module.exports = __webpack_public_path__ + "img/1384244463.77271556.jpg";